export enum InputType {
  Text,
  Diarienummer,
  Date,
  Phone,
  Amount,
  Percent,
  Zipcode,
  Number,
  Dropdown,
  Organisationsnummer,
  Bankgiro,
  PlusGiro,
}
